
  import { Vue, Component, Prop } from "vue-property-decorator";

  import AddPaymentCardForm from "@/components/payment/AddPaymentCardForm.vue";
  import PaymentOptionsList from "@/components/payment/PaymentOptionsList.vue";

  import lambdaRequest from "@/helpers/lambdaRequest";
  import Message from "@/data/notificationsMessages";

  import { NOTIFICATION } from "@/entities/Events";
  import { Payment_Card } from "@/generated/graphql";

  @Component({
    components: {
      PaymentOptionsList,
      AddPaymentCardForm,
    },
  })
  export default class CreateSubscriptionOptions extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly chosenSubscriptionPlanId!: string;
    @Prop({ type: String, required: true }) readonly cardFormTitle!: string;
    @Prop({ type: String, required: true }) readonly cardsListTitle!: string;
    @Prop({ type: Boolean, required: true }) readonly isPaymentCardsExist!: boolean;
    @Prop({ type: Array, required: true }) readonly paymentCards!: Payment_Card[];

    applyingChosenCard: boolean = false;
    creatingNewSubscription: boolean = false;
    errorMessage: string = "";

    async subscribeWithNewCard(payload: { token: string }): Promise<void> {
      this.creatingNewSubscription = true;
      const {token} = payload;

      try {
        await lambdaRequest({
          lambdaName: "subscribeWithNewCard",
          requestData: {
            token,
            user_id: this.currentUserId,
            subscription_plan_id: this.chosenSubscriptionPlanId,
          },
        });

        this.$emit("subscriptionCreated");
      } catch (error) {
        this.errorMessage = error.message;
      } finally {
        this.creatingNewSubscription = false;
      }
    }

    async subscribeWithExistingCard(cardId: string): Promise<void> {
      this.applyingChosenCard = true;
      try {
        await lambdaRequest({
          lambdaName: "subscribeWithExistingCard",
          requestData: {
            card_id: cardId,
            subscription_plan_id: this.chosenSubscriptionPlanId,
            user_id: this.currentUserId,
          },
        });

        this.$emit("subscriptionCreated");
      } catch (error) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(error.message));
      } finally {
        this.applyingChosenCard = false;
      }
    }
  }
